import { useState } from "react";
import { ChevronRightIcon } from "../../../../assets/icons";
import { formatDate, formatTimeLocal } from "../../../../utils";
import styles from "./TransactionDetail.module.scss";
import { TimelineEntry } from "./timeline";

interface TimelineItemProps {
	entry: TimelineEntry;
}

const TimelineItem = ({ entry }: TimelineItemProps) => {
	const [expanded, setExpanded] = useState(false);

	const statusClass = styles[entry.statusClass];
	const iconClass = styles[entry.iconState];
	const iconGlyph = entry.iconState === "completed" ? "✓" : entry.iconState === "pending" ? "⋯" : "✕";

	return (
		<div className={styles.timelineItem}>
			<span className={`${styles.timelineIcon} ${iconClass}`}>{iconGlyph}</span>
			<div className={styles.timelineBody}>
				<div className={styles.timelineHeader}>
					<div>
						<div className={styles.timelineTitle}>{entry.title}</div>
						<div className={styles.timelineDate}>
							{formatDate(entry.createdAt)} • {formatTimeLocal(entry.createdAt)}
						</div>
					</div>
					<div className={styles.timelineMeta}>
						<div className={`${styles.statusContainer} ${styles.timelineStatus}`}>
							<div className={`${styles.statusIndicator} ${statusClass}`}></div>
							<div className={`${styles.status} ${statusClass}`}>{entry.statusLabel}</div>
						</div>
						<span className={styles.metaLine}>{entry.meta}</span>
					</div>
				</div>
				<button type="button" className={styles.rawResponseToggle} onClick={() => setExpanded(prev => !prev)}>
					<span>Raw Provider Response</span>
					<ChevronRightIcon className={`${styles.rawChevron} ${expanded ? styles.rawChevronOpen : ""}`} height={14} />
				</button>
				{expanded && (
					<div className={styles.rawResponse}>
						{entry.rawFields.map(field => (
							<div key={field.label} className={styles.rawField}>
								<span className={styles.label}>{field.label}</span>
								<span>{field.raw ? field.value : field.value || "—"}</span>
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default TimelineItem;
